"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearchOptions = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let UniversalSearchOptions = class UniversalSearchOptions {
    constructor() {
        this.searchInOrdersPassengers = false;
        this.searchInOrdersReferences = false;
        this.searchInOrders = false;
        this.searchInUsers = false;
        this.searchInRemoved = false;
        this.skip = 1;
        this.limit = 15;
    }
};
exports.UniversalSearchOptions = UniversalSearchOptions;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UniversalSearchOptions.prototype, "searchString", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UniversalSearchOptions.prototype, "searchInOrdersPassengers", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UniversalSearchOptions.prototype, "searchInOrdersReferences", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UniversalSearchOptions.prototype, "searchInOrders", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UniversalSearchOptions.prototype, "searchInUsers", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UniversalSearchOptions.prototype, "searchInRemoved", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => (value != null ? Number(value) : value)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], UniversalSearchOptions.prototype, "skip", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => (value != null ? Number(value) : value)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], UniversalSearchOptions.prototype, "limit", void 0);
exports.UniversalSearchOptions = UniversalSearchOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], UniversalSearchOptions);
//# sourceMappingURL=UniversalSearchOptions.js.map